$('body').on('submit', '.add-card form', function() {
    var $this = $(this);
    var form = $this.parents('.add-card');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    form.find('.error').removeClass('error');
    form.find('.required').each(function() {
        var input = $(this);
        if(input.val() === '') {
            error = true;
            input.addClass('error');
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            $this[0].reset();

            var card = `<div class="card card">
                <header>
                    <h4>${data.data.card_type_parsed} - ${data.data.last_four}</h4>
                </header>

                <div class="card-details padding" data-view="details">
                    <div class="card-info">
                        <div class="card-type-small">
                            <figure>
                                <img src="images/payment-type-${data.data.card_type}.svg" alt="profile">
                            </figure>
                        </div>

                        <ul class="details-list table">
                            <li><span>Card Holder</span> <span class="highlight" data-input="card_holder" data-color="white">${data.data.card_holder}</span></li>
                            <li><span>Card Type</span> <span class="highlight" data-input="card_type_parsed" data-color="white">${data.data.card_type_parsed}</span></li>
                            <li><span>Number</span> <span class="highlight" data-input="masked_number" data-color="grey">${data.data.masked_number}</span></li>
                            <li><span>Expiry</span> <span class="highlight" data-input="expiry" data-color="white">${data.data.expiry}</span></li>
                        </ul>
                    </div>
                </div>

                <footer data-view="details">
                    <a href="" class="toggle-card-view" data-view="delete">Delete Card</a>
                </footer>

                <div class="delete-card">
                    <form action="cards/${data.data.card}" method="post">
                        <div class="card-details padding" data-view="delete">
                            <p class="light-message">
                                Are you sure you want to delete this card?
                            </p>
                        </div>

                        <footer data-view="delete">
                            <a href="" class="toggle-card-view" data-view="details">Cancel</a>
                            <input type="hidden" name="_method" value="delete">
                            <input type="submit" value="Delete Card">
                        </footer>
                    </form>
                </div>
            </div>`;

            $this.parents('.card').before(card);

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});

$('body').on('submit', '.delete-card form', function() {
    var $this = $(this);
    var form = $this.parents('.delete-card');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    form.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
            $this.parents('.card').remove();
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});